import SectionHeading from "./SectionHeading.jsx";
import { feelingItems } from "./data.js";

export default function Feeling() {
  return (
    <section className="bg-[#FFF] px-4 py-20 sm:px-6 lg:px-8 lg:py-20">
      <div className="mx-auto grid max-w-7xl items-center gap-14 lg:grid-cols-2">
        <div>
          <SectionHeading
            eyebrow="The Outcome"
            title="The feeling"
            highlight="you deserve"
          />

          <div className="mt-12 space-y-4">
            {feelingItems.map((item) => {
              const isPositive = item.tone === "positive";

              return (
                <div
                  key={item.label}
                  className={`flex items-center gap-4 rounded-[22px] border px-6 py-5 text-lg transition ${isPositive
                    ? "border-green-200 bg-green-50 text-[#0d0828]"
                    : "border-purple-100 bg-white text-[#0d082899]"
                    }`}
                >
                  <div
                    className={`flex h-10 w-10 items-center justify-center rounded-full text-sm font-montserrat font-black ${isPositive
                      ? "border border-green-200 bg-green-100 text-green-700"
                      : "border border-red-200 bg-red-50 text-red-600"
                      }`}
                  >
                    {item.isImage ? (
                      <img
                        src={item.icon}
                        alt={item.label}
                        className="max-h-6 max-w-6 object-contain"
                      />
                    ) : (
                      item.icon
                    )}
                  </div>
                  <div className="w-full">
                    <span className={isPositive ? "text-base lg:text-xl font-black font-montserrat" : "text-base lg:text-xl font-semibold font-montserrat"}>
                      {item.label}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="overflow-hidden rounded-[32px] border border-purple-100 bg-white p-10 text-center shadow-[0_24px_64px_rgba(124,58,237,0.12)] sm:p-14">
          <div className="mx-auto h-1.5 w-24 rounded-full bg-[#4C42FD]" />
          <div className="mt-8 text-5xl font-black tracking-[0.24em] bg-[#4C42FD] bg-clip-text text-transparent  font-montserrat">
            PEACE
          </div>
          <div className="mt-6 text-3xl font-black leading-tight tracking-[-0.03em] text-[#0d0828] font-montserrat">
            Financial peace
            <br />
            before checkout
          </div>
          <p className="mt-5 text-base leading-7 text-[#0d0828b3] font-montserrat">
            Not after the regret. Not during the guilt. Before the decision, your
            money is already sorted and ready for you.
          </p>
        </div>
      </div>
    </section>
  );
}
